export default {
  methods: {

    set_LocalValues() {

      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      this.dataset = JSON.parse(JSON.stringify(this.Queries.SQL1[0]))

      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.circle   = json.circle
      this.colorSet = json.colorSet
      this.guide    = json.guide
      this.legends  = json.legends
      this.sundries = json.sundries
      this.keys     = json.keys
      this.filters  = json.filters

      if(this.circle.order == 'ASC') this.rawData.sort((a, b) => a.VALUE - b.VALUE)
      if(this.circle.order == 'DESC') this.rawData.sort((a, b) => b.VALUE - a.VALUE)


      // rawData pre-processing
      let total = this.rawData.reduce((sum, obj) => sum + obj.VALUE, 0)
      let cumulative = 0
      this.rawData.forEach((d, i) => {

        cumulative = cumulative + (d.VALUE/total)
        
        d.stack = this.circle.dia - (i * this.circle.stack)
        d.angle = cumulative - (d.VALUE/total) / 2
        d.color = this.colorSet[i].color
        d.opacity = this.colorSet[i].opacity
      })
  

    },


    
  }
}
